import React, { useEffect } from 'react';
import useFetch from 'hooks/useFetch';
import { routes } from 'constants/config';
import CertificateView from './CertificateView';

function CertificateViewContainer({ match, location }) {
  const { certificateId } = match.params;
  const { search } = location;

  const { data, error, initialLoading } = useFetch(
    routes.CERTIFICATE(certificateId),
  );
  const params = new URLSearchParams(search);

  useEffect(() => {
    if (document.body?.classList) {
      // Adds css class for hiding header while printing
      document.body.classList.add('certificate-page');
    }
    return () => {
      if (document.body?.classList) {
        document.body.classList.remove('certificate-page');
      }
    };
  }, []);

  // Allow Page Error Boundary handles api errors
  useEffect(() => {
    if (error) {
      throw new Error(error);
    }
  }, [error]);

  return (
    <div className="w-fill d-f jc-c ai-c mt-48">
      <CertificateView
        isLoading={initialLoading}
        shouldPrint={params.get('print') === 'true'}
        {...data}
      />
    </div>
  );
}

export default CertificateViewContainer;
